import { SatisfactionComment } from "../../../../types/onboardingAnalytics";

// A comment longer than this, or with a line break, is collapsed to two lines
// with "Show more". Shorter ones fit and need no toggle.
const LONG_COMMENT_CHARS = 140;

export const isLongComment = (text: string): boolean =>
  text.length > LONG_COMMENT_CHARS || text.includes("\n");

export type StarFilter = "all" | "critical" | "positive";

export const STAR_FILTER_OPTIONS: { label: string; value: StarFilter }[] = [
  { label: "All", value: "all" },
  { label: "1–3 ★", value: "critical" },
  { label: "4–5 ★", value: "positive" },
];

export const filterByStars = (
  comments: SatisfactionComment[],
  filter: StarFilter
): SatisfactionComment[] => {
  if (filter === "critical") return comments.filter((c) => c.stars <= 3);
  if (filter === "positive") return comments.filter((c) => c.stars >= 4);
  return comments;
};

export const EMPTY_MESSAGES: Record<StarFilter, string> = {
  all: "No comments in this period.",
  critical: "No critical comments in this period.",
  positive: "No positive comments in this period.",
};
